import * as Styled from './SearchResultsStyles';
import searchResultsEmpty from '../../../images/search-results-empty.svg';
import {EmojiWrapper} from '../../components/EmojiWrapper';
import useObservable from '../../hooks/useObservable';
import SearchStore from '../../xstores/search';

interface SearchEmptyProps{
  canShow: boolean;
}

const SearchEmpty = ({ canShow }:SearchEmptyProps) => {
  const platformFilter = useObservable(SearchStore.platformFilter$, 'all');
  const typeFilter = useObservable(SearchStore.typeFilter$, '');
  const displayResults = useObservable(SearchStore.displayResults$, []);
  const onShowAll = () => {
    SearchStore.setFilter('all');
  }
  if (!canShow) {
    return null;
  }
  if (displayResults.length) {
    return null;
  }
  const isFiltered = platformFilter !== 'all' || !!typeFilter;
  return (
    <Styled.Container className='EmptyResults'>
      <Styled.StyledImg src={searchResultsEmpty} alt='Empty icon' />
      <Styled.StyledParagraph>
        {!isFiltered ?
          (<span>Sorry, we couldn’t find any match <EmojiWrapper>&#128547;</EmojiWrapper></span>) :
          (<span>We couldn't find results in this filter <EmojiWrapper>&#128547;</EmojiWrapper></span>)
        }
      </Styled.StyledParagraph>
      {!isFiltered ?
        <Styled.StyledSpan className='EmptyResultsSpan'>Try searching another keyword.</Styled.StyledSpan> :
        <Styled.StyledSpan className='EmptyResultsSpan'>
          Try a different filter or
          <Styled.StyledSpan
            className="ShowAllAnchor"
            onClick={onShowAll}
          >
            Show all
          </Styled.StyledSpan>
        </Styled.StyledSpan>
      }
    </Styled.Container>
  )
}

export default SearchEmpty;